module.exports = __webpack_public_path__ + "static/media/undraw_fill_forms_yltj.67d08686.svg";